export default "__VITE_ASSET__B$_52RUq__"